import { useState } from 'react';
export const useAssignRefresh = () => {
    const [refreshKey, setRefreshKey] = useState(false);

    const handleAssignSuccess = () => {
        setRefreshKey(prev => {
            return !prev;
        });
    };

    return { refreshKey, handleAssignSuccess };
};
